export default function isArrayEmpty(arr) {
    return arr.length === 0;
}